import React from "react";
import { useNavigate } from "react-router-dom";

export default function StripeCancelPage() {

  const navigate = useNavigate();

  return (
    <div style={{ padding: 20 }}>

      <h2>Payment Cancelled ❌</h2>

      <p>
        No charges were made. You can try again when you're ready.
      </p>

      <button
        onClick={() => navigate("/invoices")}
        style={{ marginTop: 10 }}
      >
        Back to Invoices
      </button>

      <button
        onClick={() => window.location.reload()}
        style={{ marginLeft: 10 }}
      >
        Try Again
      </button>

    </div>
  );
}